'use client';

import { useRouter } from 'next/navigation';
import { Box, Button, Grid, Text, Title } from '@mantine/core';
import { useInViewport } from '@mantine/hooks';
import Animation from '@/app/components/animation/Animation';
import { YouTubeEmbed } from '@/app/components/youtube/YouTubeEmbed';
import { useTranslation } from '@/i18n/client';
import classes from './Guide.module.css';

export function Guide() {
  const viewPort = useInViewport();
  const { t } = useTranslation('main');
  const { push } = useRouter();
  return (
    <Box className={classes.wrapper}>
      <Box ref={viewPort.ref} style={{ position: 'relative', top: '350px' }} />
      <Animation transition='pop' duration={600} delay={200} inViewport={viewPort.inViewport}>
        <Box className={classes.inner}>
          <Grid gutter={80}>
            <Grid.Col span={{ base: 12, md: 5 }}>
              <Title className={classes.title} order={2}>
                {t('content.guide.title')}
              </Title>
              <Text className={classes.description}>{t('content.guide.description')}</Text>

              <Button
                variant='gradient'
                gradient={{ deg: 133, from: '#171747', to: '#6300d3' }}
                size='lg'
                radius='md'
                mt='lg'
                onClick={() => push('/download')}
              >
                {t('content.guide.button').toUpperCase()}
              </Button>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 7 }}>
              <YouTubeEmbed video='fYNl9jqxySY' />
            </Grid.Col>
          </Grid>
        </Box>
      </Animation>
    </Box>
  );
}

export default Guide;
